<div class="container-fluid pt-3">
  <div class="row">
    <div class="col-4">
      <mat-form-field>
        <mat-label>Workflow Name</mat-label>
        <input
          matInput
          [disabled]="!creating && !editing"
          type="text"
          placeholder="Name"
          [(ngModel)]="wfTableConfig.name"
        />
      </mat-form-field>
    </div>
    <div class="col-1">
      <mat-form-field>
        <mat-label>Workflow ID</mat-label>
        <input
          matInput
          [disabled]="true"
          type="text"
          placeholder="ID"
          [(ngModel)]="wfTableConfig.id"
        />
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field>
        <mat-label>Document Type</mat-label>
        <mat-select
          [(ngModel)]="wfTableConfig.formType"
          [disabled]="!creating && !editing"
        >
          <mat-option
            *ngFor="let type of documentTypesFiltered"
            [value]="type.id"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-3">
      <mat-form-field>
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="wfTableConfig.status" [disabled]="true">
          <mat-option *ngFor="let s of wfStatuses" [value]="s.value">
            {{ s.key }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <comments-box
        [textValue]="wfTableConfig.description"
        title="Description"
        formType="workflow"
        serialNo="description"
        [disabled]="!creating && !editing"
        (textChanged)="wfTableConfig.description = $event"
      ></comments-box>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12">
      <workflow-sections
        [wfTableConfig]="wfTableConfig"
        [disabled]="!creating && !editing"
      ></workflow-sections>
    </div>
  </div>
</div>
